import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import { Grid, Typography } from "@mui/material";

import { formatHour, gridSize, gridSizeMdLg1, gridSizeMdLg6 } from "@/shared";
import {
  CustomTabPanel,
  CustomTextFieldNoForm,
  SingleIconButton,
} from "@/shared/components/ui";
import { AlertSeverityEnum, IPreagendamiento } from "@/shared/interfaces";
import { useInstallScheduleStore } from "@/store/erp/planeacion";
import { useUiStore } from "@/store/ui";
import { InstallScheduleComponent } from "../horario-install";
import ServiceAndOthersPartPreagendamientoForm from "./ServiceAndOthersPartPreagendamientoForm";

export type InternetServicePreagendaFormTabProps = {
  // form: UseFormReturn<SaveFornData>;
  form: any;
  index: number;
  value: number;
  shrink?: boolean;
  preagendamiento: IPreagendamiento;
  isCorrectingData?: boolean;
};

const InternetServicePreagendaFormTab: React.FC<
  InternetServicePreagendaFormTabProps
> = ({ form, index, preagendamiento, value, isCorrectingData = false }) => {
  ///* form --------------------
  const watchedFlotaRaw = form.watch("flotaRaw");

  ///* global state --------------------
  const isVisibleCalendario = useInstallScheduleStore(
    (s) => s.isVisibleCalendario,
  );
  const setIsVisibleCalendario = useInstallScheduleStore(
    (s) => s.setIsVisibleCalendario,
  );
  const thereIsCacheData = useInstallScheduleStore((s) => s.thereIsCacheData);
  const setAlert = useUiStore((s) => s.setAlert);

  ///* handlers --------------------
  const onEditHorario = async () => {
    if (thereIsCacheData) {
      setAlert(
        true,
        "Una vez modificado el horario debe confirmar el reagendamiento o esperar a que termine el tiempo de espera.",
        AlertSeverityEnum.warning,
      );
      return;
    }

    // if cancel edit, set flota to db value
    if (isVisibleCalendario) {
      form.reset({
        ...form.getValues(),
        flota: preagendamiento?.flota! || "",
        flotaRaw: preagendamiento?.flota_data! || {},
      });
    }
    setIsVisibleCalendario(isVisibleCalendario ? false : !isVisibleCalendario);
  };

  return (
    <CustomTabPanel index={index} value={value}>
      {/* ================ fecha hora instalacion ================ */}
      {!isCorrectingData ? (
        <>
          <Grid item xs={12} container pb="24px">
            <Typography
              variant="h6"
              sx={{
                display: "flex",
                alignItems: "start",
                justifyContent: "start",
                fontSize: ".9rem",
                color: "#6c737fb0",
              }}
            >
              HORARIO PREAGENDADO
            </Typography>
            <span className="spacer" />

            <SingleIconButton
              startIcon={<EventRepeatIcon />}
              color={isVisibleCalendario ? "error" : "primary"}
              label={isVisibleCalendario ? "Cancelar edición" : "Editar fecha"}
              onClick={onEditHorario}
              size={gridSizeMdLg1}
            />
          </Grid>

          <>
            {!isVisibleCalendario ? (
              <>
                <CustomTextFieldNoForm
                  label="Fecha de instalación"
                  value={preagendamiento?.fecha_instalacion || "N/A"}
                  size={gridSizeMdLg6}
                  disabled
                />
                <CustomTextFieldNoForm
                  label="Hora de instalación"
                  value={
                    preagendamiento?.hora_instalacion
                      ? formatHour(preagendamiento?.hora_instalacion)
                      : "N/A"
                  }
                  size={gridSizeMdLg6}
                  disabled
                />
                <CustomTextFieldNoForm
                  label="Flota"
                  value={watchedFlotaRaw?.nombre || "N/A"}
                  size={gridSize}
                  disabled
                />
              </>
            ) : (
              <>
                <InstallScheduleComponent
                  form={form!}
                  preventa={preagendamiento?.preventa_data!}
                />
              </>
            )}
          </>
        </>
      ) : (
        <>
          <Grid item xs={12} container pb="24px">
            <Typography
              variant="h6"
              sx={{
                display: "flex",
                alignItems: "start",
                justifyContent: "start",
                fontSize: ".9rem",
                color: "#6c737fb0",
              }}
            >
              HORARIO PREAGENDADO
            </Typography>
          </Grid>

          <CustomTextFieldNoForm
            label="Fecha de instalación"
            value={preagendamiento?.fecha_instalacion || "N/A"}
            size={gridSizeMdLg6}
            disabled
          />
          <CustomTextFieldNoForm
            label="Hora de instalación"
            value={
              preagendamiento?.hora_instalacion
                ? formatHour(preagendamiento?.hora_instalacion)
                : "N/A"
            }
            size={gridSizeMdLg6}
            disabled
          />
          <CustomTextFieldNoForm
            label="Flota"
            value={watchedFlotaRaw?.nombre || "N/A"}
            size={gridSize}
            disabled
          />
        </>
      )}

      {/* ================ Service ================ */}
      <ServiceAndOthersPartPreagendamientoForm
        form={form}
        preagendamiento={preagendamiento!}
        isCorrectingData={isCorrectingData}
      />
    </CustomTabPanel>
  );
};

export default InternetServicePreagendaFormTab;
